export const FILE_TYPE_INDEX_TO_NAME = {
  0: 'image',
  1: 'video',
  2: 'audio',
  3: 'compress',
  4: 'file',
}

//TODO: read from back
// sizes are in MB
export const MAX_VALID_FILE_SIZES_BY_PACKAGE_INDEX = {
  3: 30,
  1: 10,
  6: 10,
  2: 20,
  7: 20,
  8: 30,
  10: 100,
  11: 100,
}

export const FILE_TYPE_INDEX_BY_MIME_TYPES = {
  0: ['image/gif', 'image/jpeg', 'image/png', 'image/webp'],
  1: [
    'video/3gpp',
    'video/webm',
    'video/ogg',
    'video/mpeg',
    'video/mp4',
    'video/quicktime',
    'video/x-ms-wmv',
    'video/x-msvideo',
  ],
  2: ['audio/mpeg', 'audio/ogg', 'audio/mp3', 'audio/x-m4a'],
  3: [
    'application/zip',
    'application/x-zip-compressed',
    'application/x-rar-compressed', //.rar
    'application/x-7z-compressed',
  ],
  4: [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //.docx
    'application/pdf',
    'text/csv', //.csv,
    'application/vnd.ms-powerpoint', //.ppt
    'application/vnd.ms-excel', //.csv
  ],
}
